import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EarlyAccessComponent } from '../modules/early-access/early-access.component';
import { NewUserComponent } from '../modules/new-user/new-user.component';
import { PrivacyPolicyComponent } from '../modules/privacy-policy/privacy-policy.component';
import { RegisteredUserComponent } from '../modules/registered-user/registered-user.component';
import { TermsAndConditionsComponent } from '../modules/terms-and-conditions/terms-and-conditions.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { SubscribedUserComponent } from '../modules/subscribed-user/subscribed-user.component';
import { AppRoute } from './routing.config';
import { ErrorComponent } from '../pages/error/error.component';
import { LoginDialogComponent } from '../pages/login-dialog/login-dialog.component';
import { LogoutComponent } from '../pages/logout/logout.component';
import { WelcomeComponent } from '../modules/welcome/welcome.component';
import { WelcomeGuard } from '../core/guards/welcome.guard';

export const routes: Routes = [
  {
    path: AppRoute.WELCOME,
    component: WelcomeComponent,
    canActivate: [WelcomeGuard],
    title: "AmiLearn Portal",
  },
  {
    path: AppRoute.APP_LOGIN,
    component: LoginDialogComponent,
    title: "AmiLearn Portal: Login",
  },
  {
    path: AppRoute.APP_START,
    component: EarlyAccessComponent,
    canActivate: [AuthGuard],
    title: 'AmiLearn Portal',
  },
  {
    path: AppRoute.NEW_USER,
    component: NewUserComponent,
    canActivate: [AuthGuard],
    title: "Meetami's AmiLearn: New User",
  },
  {
    path: AppRoute.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    title: "Meetami's AmiLearn: Privacy Policy",
  },
  {
    path: AppRoute.REGISTERED_USER,
    component: RegisteredUserComponent,
    canActivate: [AuthGuard],
    title: "Meetami's AmiLearn: Registered User",
  },
  {
    path: AppRoute.SUBSCRIBED_USER,
    component: SubscribedUserComponent,
    canActivate: [AuthGuard],
    title: "Meetami's AmiLearn: Subscribed User",
  },
  {
    path: AppRoute.TERMS_AND_CONDITIONS,
    component: TermsAndConditionsComponent,
    title: "Meetami's AmiLearn: Terms and Conditions",
  },
  {
    path: AppRoute.ERROR_PAGE,
    component: ErrorComponent,
    title: 'AmiLearn Portal Error'
  },
  {
    path: AppRoute.APP_LOGOUT,
    component: LogoutComponent,
    title: 'AmiLearn Logout'
  },
  { path: '**', redirectTo: AppRoute.APP_LOGIN, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
        // enableTracing: true, // <-- debugging purposes only
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
